import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';

import '@esri/calcite-components';
import { setAssetPath } from '@esri/calcite-components/dist/components';
import '@esri/calcite-components/dist/calcite/calcite.css';
import './sass/main.scss';

import App from './App';
import Context from './context/Context';
import { initStore } from './redux/store';

// Local assets
setAssetPath(window.location.href);
// CDN hosted assets
// setAssetPath('https://unpkg.com/@esri/calcite-components/dist/calcite/assets');

// this is required
console.log(Context.instance); // initialize the instance

const store = initStore();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
